import React from 'react';
import { bool, shape, string } from 'prop-types';

const CalendarPlanColor = ({
  className = '',
  notUseClass = false,
  style = { color: '#0071CD' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.667 1.69664H11.0837V0.583008H9.91699V1.69664H4.08366V0.583008H2.91699V1.69664H2.33366C1.69199 1.69664 1.16699 2.19778 1.16699 2.81028V11.7194C1.16699 12.3319 1.69199 12.833 2.33366 12.833H6.41699V11.6663H2.33366V5.83301H11.667V6.41634H12.8337V2.81028C12.8337 2.19778 12.3087 1.69664 11.667 1.69664ZM11.667 12.833V13.4163C12.3113 13.4163 12.8337 12.894 12.8337 12.2497V11.7194C12.8337 12.3319 12.3087 12.833 11.667 12.833ZM2.33366 4.66634H11.667V2.91634H2.33366V4.66634Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5003 12.833C11.789 12.833 12.8337 11.7883 12.8337 10.4997C12.8337 9.21101 11.789 8.16634 10.5003 8.16634C9.21166 8.16634 8.16699 9.21101 8.16699 10.4997C8.16699 11.7883 9.21166 12.833 10.5003 12.833ZM10.5003 13.9997C12.4333 13.9997 14.0003 12.4327 14.0003 10.4997C14.0003 8.56668 12.4333 6.99967 10.5003 6.99967C8.56733 6.99967 7.00033 8.56668 7.00033 10.4997C7.00033 12.4327 8.56733 13.9997 10.5003 13.9997Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.792 9.04134V10.208H11.667V11.3747H9.62533V9.04134H10.792Z" fill="currentColor" />
  </svg>
);

CalendarPlanColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CalendarPlanColor;
